import React from 'react';

export default function ListSkeleton() {
  return (
    <div className="list-skeleton-wrapper">
      <div className="left" />
      <div className="right">
        <div className="skeleton" style={{ width: 453 }} />
        <div className="skeleton" />
        <div className="skeleton" />
      </div>
    </div>
  );
}
